import React from 'react';
import { Slide, Section } from 'spectacle-ppa';
import Hacked from 'components/hacked';

function finishHackedSection ({ level }) {
  return (
    <Section id="finish">

      {/* Level complete */}
      <Slide
          id="hacked"
          notes={'<h2>Level ' + level + ' Finished</h2>'}
          bgColor="black"
          hacked="cliffHanger"
          finish>
        <Hacked cliffHanger />
      </Slide>

    </Section>
  );
}

export default finishHackedSection;



// WEBPACK FOOTER //
// ./programs/zeroHeroes/sections/91_finishHacked/finishHackedSection.jsx